import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let RowContainer = class RowContainer extends Vue {};
RowContainer.componentName = 'RowContainer';
__decorate([Prop({
  default: '8px'
})], RowContainer.prototype, "rowGap", void 0);
__decorate([Prop({
  default: '8px'
})], RowContainer.prototype, "columnGap", void 0);
RowContainer = __decorate([Component({
  name: 'RowContainer'
})], RowContainer);
export default RowContainer;